import { useTranslation } from 'next-i18next';

import css from '@/src/legal/presentation/views/privacy-policy-page-view/privacy-policy-page-view.css';
import { useLanguage } from '@/src/shared/presentation/hooks/use-locale';

export default function PrivacyPolicyPageView() {
  const language = useLanguage();
  const { t } = useTranslation('legal', { keyPrefix: 'views.privacy_policy' });

  return (
    <div className={css.page}>
      <h1 className={css.title}>{t('title')}</h1>

      <p>
        <strong className={css.subtitle}>{t('subtitle')}</strong>
      </p>

      <div className={css.paragraphs}>
        {t('paragraphs', { returnObjects: true }).map((paragraph, index) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }}></p>
        ))}
      </div>

      {language === 'es' ? (
        <a
          href="https://utopicus.es/sites/default/files/paragraph/block_intro/file/2025-02/psi.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className={css.link}
        >
          {t('link')}
        </a>
      ) : null}
    </div>
  );
}
